module.exports = __webpack_public_path__ + "14b5d262e9c197ecb794f47978076ffc.pdf";